import React, { useEffect, useState } from 'react';
import { FaSync, FaTimes, FaToggleOff, FaToggleOn } from 'react-icons/fa';
import { FaCookieBite } from 'react-icons/fa6';
import rocketGIF from '../../assets/gifs/Rocket.gif';
import checkShieldGIF from '../../assets/gifs/CheckShield.gif';
import { Button, Modal } from 'react-bootstrap';
import Cookies from 'js-cookie';
import { useTranslation } from "react-i18next";

function UpdateSummaryPopup() {
    const [t, i18n] = useTranslation("updates")
    const [isVisible, setIsVisible] = useState(false);
    const [updateCookies, setUpdateCookies] = useState(Cookies.get('myreportin_version'));
    const [customizationCookies, setCustomizationCookies] = useState(Cookies.get('myreportin_cookies_enabled'));
    const newVersion = t("updatesPopup.version");
    const updateElements = [];
    let index = 1;
    const updateManual = 'https://www.myreportin.com/descargas/novedades-Myreportin.pdf';


    const handleAccept = () => {
        setIsVisible(false);
        Cookies.set('myreportin_version', newVersion, { expires: 730, secure: true, sameSite: 'none' });
        setUpdateCookies(newVersion)
    };

    const handleUpdateManualDownload = () => {
        window.open(updateManual, '_blank');
    };

    const handleOpen = () => {
        setIsVisible(true);
    };

    function openCookies() {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 2000);

        return () => clearTimeout(timer);
    }

    useEffect(() => {
        const cookiesPopupHide = sessionStorage.getItem('cookiespopuphide');
        const authInfo = localStorage.getItem("authInfo")

        if (authInfo && customizationCookies !== undefined && !cookiesPopupHide && updateCookies !== newVersion) {
            openCookies()
        }

    }, []);

    useEffect(() => {
        if (isVisible) {
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.remove('no-scroll');
        }

        // Limpieza al desmontar el componente
        return () => {
            document.body.classList.remove('no-scroll');
        };
    }, [isVisible]);



    while (index) {
        const textKey = `updatesPopup.text${index}`;
        const text = t(textKey);

        if (text === textKey) {
            break;
        }


        const htmlContent = { __html: text };
        updateElements.push(
            <p key={index} className='update-text'>
                <img
                    src={checkShieldGIF}
                    alt="Cookies GIF"
                    className='update-check-gif'
                />
                <span className='width-95' dangerouslySetInnerHTML={htmlContent}></span>
            </p>
        );

        index++; // Incrementa el índice para la siguiente iteración
    }



    return (
        <>

            <div className={`update-container ${!isVisible && 'update-container-hidden'}`}>
                <div className='update-card rounded-border-px custom-shadow-bold'>
                    <img
                        src={rocketGIF}
                        alt="Cookies GIF"
                        className='cookies-gif'
                    />
                    <Button
                        variant="none"
                        className="modal-close-button"
                        onClick={handleAccept}
                    >
                        <FaTimes />
                    </Button>


                    <h3>{t("updatesPopup.title")} v.{t("updatesPopup.version")}</h3>
                    <div className='update-text-container mb-4 mt-2'>
                        {updateElements}
                    </div>

                    <div className='d-flex flex-row justify-content-evenly w-100 mb-3'>

                        <div className='update-accept custom-shadow-bold ' onClick={handleAccept}>
                            {t("updatesPopup.accept")}
                        </div>
                        <div className='update-accept custom-shadow-bold ' onClick={() => handleUpdateManualDownload()}>
                            {t("updatesPopup.updateDetails")}
                        </div>

                    </div>
                </div>
            </div>
            {isVisible && <div class="fade modal-backdrop show"></div>}

        </>
    )

}

export default UpdateSummaryPopup;
